import { create } from "zustand";

import { useUserStore } from "./userStore";

type PmView = "projects" | "avis";

interface HomePmViewStore {
  view: PmView;
  setView: (view: PmView) => void;
}

export const useHomePmViewStore = create<HomePmViewStore>((set) => ({
  view: "projects",
  setView: (view) => set({ view }),
}));

// Reset view whenever the role changes
let prevRole = useUserStore.getState().user.role;
useUserStore.subscribe((state) => {
  if (state.user.role !== prevRole) {
    prevRole = state.user.role;
    useHomePmViewStore.getState().setView("projects");
  }
});
